import { render } from "./DimmActuator.vue?vue&type=template&id=0b9729e9&ts=true"
import script from "./DimmActuator.vue?vue&type=script&lang=ts"
export * from "./DimmActuator.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__